// import React from 'react';
import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

import './Clock.css';
import { useAppSelector } from '@store/hooks';
import { getIfShowFreeTime, getRemainTime } from '@store/ui/ui.slice';
import { t } from 'i18next';

const FullScreen = () => {
  dayjs.extend(duration);
  const [seconds, setSeconds] = useState(0);
  // const [isRunning, toggleIsRunning] = useState(true);
  const ifShowFreeTime = useAppSelector(getIfShowFreeTime);
  const remainTime = useAppSelector(getRemainTime);

  const showFreeTime = ifShowFreeTime && remainTime > 0;
  useEffect(() => {
    if (showFreeTime) {
      setSeconds(0);
    }
  }, [ifShowFreeTime, remainTime]);
  useInterval(() => {
    setSeconds(seconds + 1);
  }, 1000);

  return (
    <div className="header__widget">
      <div className={`header__widget--clock ${showFreeTime ? 'header__widget--clock__free' : ''}`}>
        {dayjs.duration(seconds * 1000).format('HH:mm:ss')}
        {showFreeTime ? (
          <div className="header__widget--free-time">
            （{Math.floor(remainTime / 60)}
            {t('分钟')}）
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FullScreen;
